var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-card', {
    attrs: {
      "header": "3d Switch"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "3d",
      "variant": "primary",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "3d",
      "variant": "secondary",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "3d",
      "variant": "success",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "3d",
      "variant": "warning",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "3d",
      "variant": "info",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "3d",
      "variant": "danger",
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch default"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "primary",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "secondary",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "success",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "warning",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "info",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "danger",
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch default - pills"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "primary",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "secondary",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "success",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "warning",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "info",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "danger",
      "pill": true,
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch outline"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "primary-outline",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "secondary-outline",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "success-outline",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "warning-outline",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "info-outline",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "danger-outline",
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch outline - pills"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "primary-outline",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "secondary-outline",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "success-outline",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "warning-outline",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "info-outline",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "danger-outline",
      "pill": true,
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch outline alternative"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "primary-outline-alt",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "secondary-outline-alt",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "success-outline-alt",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "warning-outline-alt",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "info-outline-alt",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "danger-outline-alt",
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch outline alternative - pills"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "primary-outline-alt",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "secondary-outline-alt",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "success-outline-alt",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "warning-outline-alt",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "info-outline-alt",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "default",
      "variant": "danger-outline-alt",
      "pill": true,
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with text"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "primary",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "secondary",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "success",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "warning",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "info",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "danger",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with text - pills"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "primary",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "secondary",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "success",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "warning",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "info",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "danger",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with text outline"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "primary-outline",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "secondary-outline",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "success-outline",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "warning-outline",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "info-outline",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "danger-outline",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with text outline - pills"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "primary-outline",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "secondary-outline",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "success-outline",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "warning-outline",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "info-outline",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "danger-outline",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with text outline alternative"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "primary-outline-alt",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "secondary-outline-alt",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "success-outline-alt",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "warning-outline-alt",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "info-outline-alt",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "danger-outline-alt",
      "on": "On",
      "off": "Off",
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with text outline alternative - pills"
    }
  }, [_c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "primary-outline-alt",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "secondary-outline-alt",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "success-outline-alt",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "warning-outline-alt",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "info-outline-alt",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  }), _vm._v("\n           \n        "), _c('c-switch', {
    attrs: {
      "type": "text",
      "variant": "danger-outline-alt",
      "on": "On",
      "off": "Off",
      "pill": true,
      "checked": true
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with icon"
    }
  }, [_c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "primary",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "secondary",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "success",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "warning",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "info",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "danger",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with icon - pills"
    }
  }, [_c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "primary",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "secondary",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "success",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "warning",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "info",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "danger",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with icon outline"
    }
  }, [_c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "primary-outline",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "secondary-outline",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "success-outline",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "warning-outline",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "info-outline",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "danger-outline",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with icon outline - pills"
    }
  }, [_c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "primary-outline",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "secondary-outline",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "success-outline",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "warning-outline",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "info-outline",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "danger-outline",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with icon outline alternative"
    }
  }, [_c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "primary-outline-alt",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "secondary-outline-alt",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "success-outline-alt",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "warning-outline-alt",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "info-outline-alt",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "danger-outline-alt",
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-card', {
    attrs: {
      "header": "Switch with icon outline alternative - pills"
    }
  }, [_c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "primary-outline-alt",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "secondary-outline-alt",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "success-outline-alt",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "warning-outline-alt",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "info-outline-alt",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false)), _vm._v("\n           \n        "), _c('c-switch', _vm._b({
    attrs: {
      "type": "icon",
      "variant": "danger-outline-alt",
      "pill": true,
      "checked": true
    }
  }, 'c-switch', {
    on: '\uf00c',
    off: '\uf00d'
  }, false))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          Sizes\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body p-0"
  }, [_c('table', {
    staticClass: "table table-hover table-striped table-align-middle mb-0"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("\n                  Large\n                ")]), _vm._v(" "), _c('td', [_c('c-switch', {
    attrs: {
      "type": "3d",
      "variant": "primary",
      "size": "lg",
      "checked": true
    }
  })], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  Normal\n                ")]), _vm._v(" "), _c('td', [_c('c-switch', {
    attrs: {
      "type": "3d",
      "variant": "primary",
      "checked": true
    }
  })], 1), _vm._v(" "), _c('td', [_vm._v("\n                  -\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  Small\n                ")]), _vm._v(" "), _c('td', [_c('c-switch', {
    attrs: {
      "type": "3d",
      "variant": "primary",
      "size": "sm",
      "checked": true
    }
  })], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  Extra small\n                ")]), _vm._v(" "), _c('td', [_c('c-switch', {
    attrs: {
      "type": "3d",
      "variant": "primary",
      "size": "xs",
      "checked": true
    }
  })], 1), _vm._v(" "), _vm._m(3)])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("Example")]), _vm._v(" "), _c('th', [_vm._v("CSS Class")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                  Add following code "), _c('code', [_vm._v("size=\"lg\"")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                  Add following code "), _c('code', [_vm._v("size=\"sm\"")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                  Add following code "), _c('code', [_vm._v("size=\"xs\"")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c34a2d3a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/Switches.vue
// module id = 959
// module chunks = 1